import React, { CSSProperties, FC } from 'react';

export interface INoFileProps {
  isMultiFileUpload?: boolean;
  fontCssStyles?: CSSProperties;
}

export const NoFile: FC<INoFileProps> = props => {
  return (
    <div className="dp-file-upload-area__info full-size">
      <div className="dp-file-upload-area__icon"></div>
      <span className="dp-file-upload-area__text" style={props.fontCssStyles}>
        {props.isMultiFileUpload ? 'Drag File(s) Here' : 'Drag File Here'}
      </span>
    </div>
  );
};
